import path from "path";
import { cliValidateEnvx, loadEnvxFromString } from "../../src/core";
import { readFileSafe } from "../../src/envx";
import { logger } from "../../shared/logger";

interface ValidateOptions {
  input: string;
}

export async function validate(options: ValidateOptions) {
  const inputPath = path.resolve(process.cwd(), options.input);

  try {
    const content = await readFileSafe(inputPath);
    const { result, schema } = loadEnvxFromString(content, {}, true);
    const { valid, errors } = cliValidateEnvx(result, schema);

    if (valid) {
      logger.success("✅ No validation errors found in .envx file.");
    } else {
      console.log(errors);
      process.exit(1); // fail with non-zero code
    }
  } catch (err) {
    logger.error(`❌ Failed to validate .envx file: ${err.message || err}`);
    process.exit(1);
  }
}